import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  sliderWrapper: {
    '& div': {
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    '& .slick-list': {
      height: 'min-content !important',
    },
    '& li.slick-active button::before': {
      backgroundColor: '#233B58',
      opacity: 1,
      content: "''",
    },
    '& li': {
      height: 'fit-content',
      width: 'fit-content',
      '& button': {
        height: 'fit-content',
        width: 'fit-content',

        '&::before': {
          color: 'transparent',
          opacity: 1,
          border: '2px solid #233B58',
          borderRadius: '50%',
          height: theme.spacing(5),
          width: theme.spacing(5),
        },
      },
    },

    '& .slick-slide': {
      height: 'auto',
    },
    '& .slick-track': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
    },
  },
}));
